import React from 'react'

import { Button, ModalBase } from '@components/atoms'
import { trackingAPI } from '@services/TrackingAPI'
import { useAppSelector } from '@store/hooks'

import { styleModalFreeLimit } from './styles'

const { Title, Info, ButtonsContainer } = styleModalFreeLimit

export const ModalFreeLimit = () => {
	const {
		modal: { modalName, modalInfo },
		profile: { id: clientId },
	} = useAppSelector((state) => state)

	const [setTracking] = trackingAPI.useSetTrackingMutation()

	return (
		<ModalBase
			title=''
			open={modalName === 'freeLimit'}
			variant='freeLimitedIcon'
		>
			<div>
				{modalInfo?.title && <Title>{modalInfo.title}</Title>}
				{!modalInfo?.noShowInfo && (
					<Info>
						Seja membro Premium e desbloqueie benefícios e conteúdos exclusivos!
					</Info>
				)}
				{modalInfo?.button && (
					<ButtonsContainer>
						<a
							href={
								modalInfo.button?.url ||
								'https://www.decorandoaleiseca.com.br/assinaturas/membro-premium'
							}
							target='_blank'
							rel='noopener noreferrer'
							style={{ width: '100%' }}
						>
							<Button
								onClick={() =>
									modalInfo?.button?.action
										? modalInfo?.button?.action()
										: setTracking({
												clientId,
												action: 'questionCTA',
										  })
								}
								icon={modalInfo?.button?.icon}
								color='orange'
								css={{
									minHeight: '48px',
									textAlign: 'center',
									_font: 'medium',
									fontWeight: 500,
								}}
							>
								{modalInfo.button?.label}
							</Button>
						</a>
					</ButtonsContainer>
				)}
			</div>
		</ModalBase>
	)
}
